import {ChangeDetectionStrategy, Component, computed, input, signal} from '@angular/core';
import {MatTooltipModule} from '@angular/material/tooltip';
import {NgStyle} from '@angular/common';

import {User} from '../../../core/model/user';
import {PipesModule} from '../../pipes/pipes.module';
import {getColorForName} from '../../utils/name-to-color.util';

@Component({
  selector: 'oph-avatar',
  standalone: true,
  imports: [PipesModule, NgStyle, MatTooltipModule],
  templateUrl: './oph-avatar.component.html',
  styleUrl: './oph-avatar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OphAvatarComponent {
  defaultSize = 26; //px
  user = input<User | null>(null);
  type = input<'user' | 'other'>('user');
  name = input<string>(); // Used for other types of avatars in case user is not provided
  size = input<number>();
  imgUrl = input<string>();
  empty = input<boolean>();
  background = input<string>();
  imgStyle = input<{[key: string]: string} | null>(null);
  tooltipText = input<string>('');
  tooltipTextCharLimit = signal(20);
  tooltipPosition = input<'above' | 'below' | 'left' | 'right'>('above');
  tooltipTextLimited = computed(() =>
    this.tooltipText()?.length > this.tooltipTextCharLimit()
      ? this.tooltipText().slice(0, this.tooltipTextCharLimit()) + '...'
      : this.tooltipText()
  );
  isTooltipDisabled = input<boolean>(true);
  userColor = computed(() => {
    if (this.background()) {
      return this.background();
    }
    return getColorForName(this.getNameForColor());
  });

  userFullName = computed(() => {
    if (!this.user()) return '';
    return `${this.user().firstName} ${this.user().lastName}`;
  });

  imgCustomStyle = computed(() => {
    if (this.imgStyle()) return this.imgStyle();
    return {
      width: `${this.size() || this.defaultSize}px`,
      height: `${this.size() || this.defaultSize}px`,
    };
  });

  private getNameForColor(): string {
    const user = this.user();

    if (user?.firstName && user?.lastName) {
      const fullName = `${user.firstName} ${user.lastName}`;
      return fullName.split(' ').join('');
    }

    if (user?.username) {
      return user.username.split(' ').join('');
    }

    if (this.name()) {
      return this.name().split(' ').join('');
    }

    return '';
  }
}
